import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  transform(args: any[], text: string, colum: string): any {
    if ( text === '' || text === undefined) {
      return args;
    }

    text = text.toLowerCase();
    return args.filter( item => {
      return item[colum].toLowerCase()
          .includes(text);
    });
  }

}
